(function () {
  'use strict';

  function on(sel, fn) {
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest(sel) : null;
      if (el) fn(el, e);
    });
  }

  /* mobile nav */
  on('[data-mp-burger]', function () {
    var nav = document.querySelector('[data-mp-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  /* quantity steppers */
  on('[data-mp-qty]', function (btn) {
    var input = btn.parentNode.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var step = parseInt(btn.getAttribute('data-mp-qty'), 10) || 0;
    input.value = Math.max(min, (parseInt(input.value || '1', 10) || 1) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function euro(cents) {
    var n = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    var parts = n.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '\u20AC' + parts.join(',');
  }

  function variants(root) {
    var tag = root.querySelector('[data-mp-variants]');
    if (!tag) return [];
    try { return JSON.parse(tag.textContent) || []; } catch (err) {
      if (window.console) console.warn('[MokaPrime] variant JSON non valido', err);
      return [];
    }
  }

  function optIndex(root) {
    var el = root.querySelector('[data-mp-option-position]');
    var i = el ? parseInt(el.value, 10) : 0;
    return isNaN(i) ? 0 : i;
  }

  function showMedia(root, mi) {
    var slides = root.querySelectorAll('[data-mp-slide]');
    var thumbs = root.querySelectorAll('[data-mp-thumb]');
    if (!slides.length || mi < 0 || mi >= slides.length) return;
    for (var i = 0; i < slides.length; i++) slides[i].classList.toggle('is-active', i === mi);
    for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('is-active', j === mi);
  }

  function total(root) {
    var el = root.querySelector('[data-mp-total]');
    var idInput = root.querySelector('[data-mp-variant-id]');
    var qtyInput = root.querySelector('[data-mp-qty-input]');
    if (!el || !idInput) return;
    var list = variants(root);
    var v = null;
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(idInput.value)) v = list[i];
    if (!v) return;
    var q = qtyInput ? (parseInt(qtyInput.value || '1', 10) || 1) : 1;
    el.textContent = euro(v.price * q);
  }

  function apply(root, v) {
    if (!v) return;
    var idInput = root.querySelector('[data-mp-variant-id]');
    if (idInput) idInput.value = v.id;

    var priceEl = root.querySelector('[data-mp-price]');
    if (priceEl) priceEl.textContent = euro(v.price);

    var wasEl = root.querySelector('[data-mp-was]');
    var saveEl = root.querySelector('[data-mp-save]');
    var discounted = v.compare_at_price && v.compare_at_price > v.price;
    if (wasEl) { wasEl.hidden = !discounted; if (discounted) wasEl.textContent = euro(v.compare_at_price); }
    if (saveEl) { saveEl.hidden = !discounted; if (discounted) saveEl.textContent = 'Risparmi ' + euro(v.compare_at_price - v.price); }

    var i = optIndex(root);
    var value = (v.options || [])[i];

    var nameEl = root.querySelector('[data-mp-variant-name]');
    if (nameEl) nameEl.textContent = value || v.title;

    var sw = root.querySelectorAll('[data-mp-swatch]');
    for (var k = 0; k < sw.length; k++) {
      var on = String(sw[k].getAttribute('data-mp-swatch')) === String(value);
      sw[k].classList.toggle('is-active', on);
      sw[k].setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    showMedia(root, typeof v.media === 'number' && v.media >= 0 ? v.media : 0);

    var submitEl = root.querySelector('[data-mp-submit]');
    if (submitEl) {
      submitEl.disabled = !v.available;
      var label = submitEl.querySelector('[data-mp-label]');
      if (label) label.textContent = v.available ? (submitEl.getAttribute('data-mp-label-buy') || 'Acquista ora') : 'Esaurito';
    }

    total(root);

    try {
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    } catch (err) {}
  }

  /* swatch clicks — delegated, so they work even if the page was re-rendered */
  on('[data-mp-swatch]', function (btn, e) {
    e.preventDefault();
    var root = btn.closest('[data-mp-product]');
    if (!root) return;
    var list = variants(root);
    var i = optIndex(root);
    var wanted = btn.getAttribute('data-mp-swatch');
    var match = null;
    for (var k = 0; k < list.length; k++) {
      if (String((list[k].options || [])[i]) === String(wanted)) { match = list[k]; break; }
    }
    if (!match) {
      var fallback = parseInt(btn.getAttribute('data-mp-swatch-index') || '0', 10);
      match = list[fallback] || list[0];
    }
    apply(root, match);
  });

  /* gallery thumbnails */
  on('[data-mp-thumb]', function (btn, e) {
    e.preventDefault();
    var root = btn.closest('[data-mp-product]');
    if (!root) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mp-thumb]'));
    showMedia(root, thumbs.indexOf(btn));
  });

  /* quantity changes keep the button total in sync */
  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest ? e.target.closest('[data-mp-qty-input]') : null;
    if (!input) return;
    var root = input.closest('[data-mp-product]');
    if (root) total(root);
  });

  /* initial state */
  function init() {
    var roots = document.querySelectorAll('[data-mp-product]');
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      var list = variants(root);
      if (!list.length) continue;
      var idInput = root.querySelector('[data-mp-variant-id]');
      var current = null;
      for (var k = 0; k < list.length; k++) if (idInput && String(list[k].id) === String(idInput.value)) current = list[k];
      apply(root, current || list[0]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
